var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nl-single",class:{ 'nl-single--riv': _vm.isRiv }},[_c('div',{staticClass:"nl-single__card"},[_c('ProductLogo',{staticClass:"nl-single__header"}),_c('main',{staticClass:"nl-single__body",attrs:{"role":"main"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }